import type { ConfigurationContextValue } from "./ConfigurationContext";

export const defaultDarkModeLogo = "./logos/logo_atomic_crm_dark.svg";
export const defaultLightModeLogo = "./logos/logo_atomic_crm_light.svg";

export const defaultCurrency = "USD";

export const defaultTitle = "Atomic CRM";

export const defaultCompanySectors = [
  { value: "communication-services", label: "Communication Services" },
  { value: "consumer-discretionary", label: "Consumer Discretionary" },
  { value: "consumer-staples", label: "Consumer Staples" },
  { value: "energy", label: "Energy" },
  { value: "financials", label: "Financials" },
  { value: "health-care", label: "Health Care" },
  { value: "industrials", label: "Industrials" },
  { value: "information-technology", label: "Information Technology" },
  { value: "materials", label: "Materials" },
  { value: "real-estate", label: "Real Estate" },
  { value: "utilities", label: "Utilities" },
];

export const defaultCompanySpecializations = [
  { value: "statutory_audit", label: "Обязательный аудит" },
  { value: "initiative_audit", label: "Инициативный аудит" },
  {
    value: "financial_statement_audit",
    label: "Аудит бухгалтерской/финансовой отчётности",
  },
  { value: "ifrs", label: "МСФО" },
  { value: "tax_audit", label: "Налоговый аудит" },
  { value: "tax_consulting", label: "Налоговый консалтинг" },
  { value: "accounting_outsourcing", label: "Бухгалтерский аутсорсинг" },
  { value: "accounting_recovery", label: "Восстановление учёта" },
  { value: "legal_services", label: "Юридические услуги" },
  { value: "valuation", label: "Оценка" },
  { value: "due_diligence", label: "Due diligence" },
  { value: "internal_audit", label: "Внутренний аудит" },
  { value: "it_audit", label: "ИТ-аудит" },
  { value: "forensic", label: "Форензик" },
  { value: "compliance", label: "Комплаенс" },
  { value: "management_consulting", label: "Управленческий консалтинг" },
  { value: "banking_finance", label: "Банки и финансовые организации" },
  { value: "insurance", label: "Страховые организации" },
  { value: "public_interest", label: "Общественно значимые организации" },
];

export const defaultDealStages = [
  { value: "lead-base", label: "В базе" },
  { value: "first-contact", label: "Первый контакт" },
  { value: "qualification", label: "Общение / квалификация" },
  { value: "presentation-sent", label: "Презентация отправлена" },
  { value: "demo-scheduled", label: "Демо запланировано" },
  { value: "demo-done", label: "Демо проведено" },
  { value: "contract-preparation", label: "Подготовка договора" },
  { value: "invoice-sent", label: "Счет выставлен" },
  { value: "won", label: "Оплата" },
  { value: "implementation", label: "Внедрение" },
  { value: "active-client", label: "Клиент активен" },
  { value: "lost", label: "Отказ" },
];

export const defaultDealPipelineStatuses = ["won", "active-client", "lost"];

export const defaultDealCategories = [
  { value: "doka-initial-sale", label: "Продажа Doka" },
  { value: "implementation", label: "Внедрение" },
  { value: "support", label: "Поддержка" },
  { value: "feature-presentation", label: "Новый функционал" },
  { value: "upsell", label: "Допродажа" },
  { value: "other", label: "Другое" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Cold", color: "#7dbde8" },
  { value: "warm", label: "Warm", color: "#e8cb7d" },
  { value: "hot", label: "Hot", color: "#e88b7d" },
  { value: "in-contract", label: "In Contract", color: "#a4e87d" },
];

export const defaultTaskTypes = [
  { value: "none", label: "None" },
  { value: "email", label: "Email" },
  { value: "demo", label: "Demo" },
  { value: "lunch", label: "Lunch" },
  { value: "meeting", label: "Meeting" },
  { value: "follow-up", label: "Follow-up" },
  { value: "thank-you", label: "Thank you" },
  { value: "ship", label: "Ship" },
  { value: "call", label: "Call" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  companySpecializations: defaultCompanySpecializations,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
